import { CloudArrowUpIcon } from "@";
import React from "react";

interface UploadProps {
  upload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  text?: string;
  title?: string;
  accept?: string;
  name?: string;
  multiple?: boolean;
  disabled?: boolean;
  star?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const Upload = ({
  upload,
  text,
  title,
  accept,
  name,
  multiple,
  disabled,
  star,
  className,
  children,
}: UploadProps) => {
  return (
    <label
      title={title}
      className={`group relative mx-auto flex w-full flex-col justify-center overflow-hidden rounded-2xl border-2 border-dashed border-gray-200 bg-gradient-to-br from-gray-50/80 via-white to-purple-50/30 p-4 text-center transition-all duration-300 dark:border-gray-600 dark:from-gray-700 dark:via-gray-800 dark:to-purple-950/20 md:mx-0 ${className} ${
        disabled
          ? "cursor-not-allowed opacity-60"
          : "cursor-pointer hover:-translate-y-px hover:border-purple-400 hover:from-purple-50/60 hover:via-white hover:to-purple-50 hover:shadow-md hover:shadow-purple-900/5 dark:hover:border-purple-500 dark:hover:from-purple-950/40 dark:hover:via-gray-800 dark:hover:to-purple-950/30"
      }`}
    >
      {/* Decorative corner orb */}
      <span
        aria-hidden
        className="pointer-events-none absolute -end-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br from-purple-200/30 to-transparent blur-2xl transition-opacity duration-300 group-hover:opacity-100 dark:from-purple-700/20"
      />

      <div className="relative flex items-center justify-center gap-2">
        {!children && (
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-purple-700 ring-1 ring-purple-100 transition-all duration-300 group-hover:bg-purple-100 group-hover:text-purple-900 group-hover:ring-purple-200 dark:bg-gray-900 dark:text-purple-300 dark:ring-purple-800/40 dark:group-hover:bg-purple-900/40">
            <CloudArrowUpIcon className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5" />
          </span>
        )}
        {children}
        <p className="text-[15px] font-medium tracking-tight text-gray-700 dark:text-gray-300">
          {!text && <>اختر ملف للرفع</>}
          {text?.slice(0, 25)}
        </p>
        {star && <span className="star">*</span>}
      </div>

      <input
        hidden
        type="file"
        name={name}
        disabled={disabled}
        multiple={multiple}
        onChange={(e) => {
          upload(e);
          e.target.value = "";
        }}
        accept={accept || ".png, .jpg, .jpeg"}
      />
    </label>
  );
};

export default Upload;
